<div v-if="items[0]" class="c-multiple-checkbox">
    <div class="col-12 c-checkbox-header">
        <label v-if="label" class="bold">{{ $t(label) }}</label>
        <label v-if="!isDisabled" class="bold" style="color: var(--secondary);user-select: none;">
            <input type="checkbox" v-model="selectAll" class="input-checkbox">
            {{ $t('componentSelectAndDeselectAll') }}
        </label>
    </div>

    <div class="main-checkbox mt25">
        <div v-for="group in items" :key="group?.[itemValue]" class="col-6 col-md-6 col-sm-12 c-checkbox-wrapper">
            <label class="bold mb5">
                <input type="checkbox" :checked="isGroupSelected(group)" @change="toggleGroupSelected(group)" class="input-checkbox" :disabled="isDisabled">
                {{ group?.[itemLabel] || "N/A" }}
            </label>
            <div v-for="child in group?.children" :key="child?.[itemValue]" style="margin-left: 28px;" :class="{'mt10': child?.[itemLabel]?.includes('View')}" class="mt10">
                <label :class="{'txt-info bold': child?.[itemLabel]?.includes('View')}">
                    <input type="checkbox" :checked="isSelected(child)" @change="toggleSelect(child)" class="input-checkbox" :disabled="isDisabled">
                    {{ child?.[itemLabel] || "N/A" }}
                </label>
            </div>
            <br>
        </div>
    </div>
</div>
<div v-else>
    Something wrong...
</div>